import { Service, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ClientCompanyDataService } from '@data-services/companies';
import { ErrorHandlingService } from '@errors/error-handling.service';
import { DataContext } from '@services/data-context';
import { ProjectAccessService } from '@services/project-scope';

@Service()
export class CompanyAccessService {
  private readonly dataContext = inject(DataContext);
  private readonly clientCompanyDataService = inject(ClientCompanyDataService);
  private readonly projectAccess = inject(ProjectAccessService);
  private readonly errorHandler = inject(ErrorHandlingService);
  private readonly translate = inject(TranslateService);

  loadProjectDetailsAsync(projectId: string): Promise<void> {
    return this.projectAccess.loadProjectDetailsAsync(projectId);
  }

  async loadCompanyByIdAsync(companyId: string): Promise<boolean> {
    try {
      const company = await this.clientCompanyDataService.getCompanyByIdAsync(companyId);
      if (!company) {
        return false;
      }

      this.dataContext.completeCompanyContext(company);
      return true;
    } catch (error: unknown) {
      await this.errorHandler.handleErrorAsync(error, this.translate.instant('general.loadCompanyError')).catch(() => undefined);
      return false;
    }
  }
}
